export default "__VITE_ASSET__e973eece__"